"use client";

import clsx from "clsx";
import { JSX, memo } from "react";
import { BsFillExclamationCircleFill } from "react-icons/bs";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";

const ErrorModal = memo(
  ({
    isOpen,
    title = "送信に失敗しました",
    message = "時間をおいてもう一度お試しください",
    subMessage,
    onClose,
  }: {
    isOpen: boolean;
    title?: string;
    message?: string;
    subMessage?: JSX.Element;
    onClose: () => void;
  }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="flex w-full flex-col items-center">
          <div className="flex w-full items-center justify-center rounded-t-lg bg-attention py-[34.5px]">
            <BsFillExclamationCircleFill className="fill-white text-[20px]" />
            <p className="ml-2 text-[19.2px] text-white">{title}</p>
          </div>
          <div className="flex flex-col items-center pb-5">
            <p className={clsx(subMessage != null ? "mt-[22px]" : "mt-8", "text-center text-[16px]")}>{message}</p>
            {subMessage != null && subMessage}
            <div className={clsx(subMessage != null ? "mt-4" : "mt-8")}>
              <Button text="閉じる" onClick={onClose} style={ButtonStyle.OUTLINE} width="w-[160px]" />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
);

ErrorModal.displayName = "ErrorModal";

export default ErrorModal;
